import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { IDetailLoctaion } from '../../../types';
import LocationTags from './LocationTags';

const MAP_STYLES = { width: '100%', height: '500px', };

const LocationInformation: React.FC<IDetailLoctaion> = ({ locationData, canViewLocation, onEditTag }) => {

    const { isLoaded } = useJsApiLoader({ googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || '', id: 'sixd-google-map' });

    const MAP_CENTER = { lat: locationData?.coordinates?.coordinates?.[0], lng: locationData?.coordinates?.coordinates?.[1] };

    return (
        <div className="li-grid">

            {/*Left: Location Details */}
            <div className="li-card">
                <h3 className="li-card__heading">Location Details</h3>

                {/* Address */}
                <div className="li-field">
                    <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                        <img src="/assets/images/location-pin-icon.svg" alt="" />
                    </div>
                    <div className="li-field__content">
                        <span className="li-field__label">Address</span>
                        <span className="li-field__value">
                            {locationData?.address || 'NA'}
                        </span>
                    </div>
                </div>

                {/* W3W */}
                {/* <div className="li-field">
                    <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                        <img src="/assets/images/calendar-icon.svg" alt="" />
                    </div>
                    <div className="li-field__content">
                        <span className="li-field__label">Access W3W</span>
                        <span className="li-field__value">{`${DateUtils.formatDateTime(locationData?.created_at, 'DD/MM/YYYY HH:mm')}`}</span>
                    </div>
                </div> */}

                {/* Google Map */}
                <div className="li-map">
                    {isLoaded ? (
                        <GoogleMap
                            mapContainerStyle={MAP_STYLES}
                            center={MAP_CENTER}
                            zoom={13}
                            options={{
                                disableDefaultUI: true,
                                zoomControl: true,
                                scrollwheel: false,
                            }}
                        >
                            <Marker position={MAP_CENTER} />
                        </GoogleMap>
                    ) : (
                        <div className="li-map__placeholder">
                            <span>Loading map...</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Right column */}
            {canViewLocation &&
                <div className="li-right">
                    {/* Contact Information card */}
                    <div className="li-card">
                        <h3 className="li-card__heading">Contact Information</h3>
                        <div className="li-field">
                            <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                                <img src="/assets/images/contact-person-icon.svg" alt="" />
                            </div>
                            <div className="li-field__content">
                                <span className="li-field__label">Contact</span>
                                <span className="li-field__value">{locationData?.contact_person || 'NA'}</span>
                            </div>
                        </div>
                        <div className="li-field">
                            <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                                <img src="/assets/images/email-icon.svg" alt="" />
                            </div>
                            <div className="li-field__content">
                                <span className="li-field__label">Email</span>
                                <span className="li-field__value">{locationData?.contact_email || 'NA'}</span>
                            </div>
                        </div>
                        <div className="li-field">
                            <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                                <img src="/assets/images/phone-icon.svg" alt="" />
                            </div>
                            <div className="li-field__content">
                                <span className="li-field__label">Phone</span>
                                <span className="li-field__value">{locationData?.contact_phone_number || 'NA'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Other Information card */}
                    <div className="li-card">
                        <h3 className="li-card__heading">Other Information</h3>
                        <div className="li-field">
                            <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                                <img src="/assets/images/camera-icon.svg" alt="" />
                            </div>
                            <div className="li-field__content">
                                <span className="li-field__label">Shoot Rate</span>
                                <span className="li-field__value">£{locationData?.shoot_rate || '0.00'}</span>
                            </div>
                        </div>
                        <div className="li-field">
                            <div className="li-field__icon-wrap li-field__icon-wrap--purple">
                                <img src="/assets/images/calendar-icon.svg" alt="" />
                            </div>
                            <div className="li-field__content">
                                <span className="li-field__label">Date Scouted</span>
                                <span className="li-field__value">{locationData?.date_scouted || 'NA'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {locationData?.tags?.length > 0 &&
                <LocationTags
                    tags={locationData?.tags}
                    onEditTag={onEditTag}
                />
            }
        </div>
    );
};

export default LocationInformation;